export function breakpoint() {
    return window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');
}

export function viewWidth() {
    return window.innerWidth;
}

export function isTouchDevice() {
    // https://stackoverflow.com/a/4819886/3717467
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

export function wait(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

export function nextFrame() {
    return new Promise(resolve => {
        window.requestAnimationFrame(resolve);
    });
}

export function preventWrap(callback) {
    return function (event) {
        event.preventDefault();
        callback(event); // useful if async
    };
}

export function hide($el) {
    $el.css('opacity', 0);
}

export function show($el) {
    $el.css('opacity', 1);
}

export function clip(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
